import { render, staticRenderFns } from "./ModalUpdate.vue?vue&type=template&id=5cbd3832&scoped=true&"
import script from "./ModalUpdate.vue?vue&type=script&lang=ts&"
export * from "./ModalUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./ModalUpdate.vue?vue&type=style&index=0&id=5cbd3832&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd3832",
  null
  
)

export default component.exports